import React from 'react';
import Chart from 'react-apexcharts';
import styles from './Dashboard.module.css';

const SubmissionsChart = ({ submissionData }) => {
    const chartOptions = {
        chart: {
            type: 'area',
            height: 350,
            toolbar: {
                show: false
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        colors: ['#10b981', '#f59e0b'],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.6,
                opacityTo: 0.1,
                stops: [0, 90, 100]
            }
        },
        xaxis: {
            categories: submissionData.dates,
            title: {
                text: 'Date',
                style: {
                    fontSize: '14px',
                    fontWeight: 600
                }
            },
            labels: {
                formatter: function (value) {
                    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const date = new Date(value);
                    return `${date.getDate()}-${months[date.getMonth()]}`;
                }
            }
        },
        yaxis: {
            title: {
                text: 'Number of Submissions',
                style: {
                    fontSize: '14px',
                    fontWeight: 600
                }
            },
            labels: {
                formatter: function (value) {
                    return Math.floor(value);
                }
            }
        },
        tooltip: {
            x: {
                format: 'dd MMM yyyy'
            },
            y: {
                formatter: function (value) {
                    return value + ' submissions';
                }
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            fontSize: '14px',
            fontWeight: 500,
            markers: {
                width: 10,
                height: 10,
                radius: 12
            }
        },
        grid: {
            borderColor: '#f1f1f1',
            strokeDashArray: 4
        }
    };

    const chartSeries = [
        {
            name: 'Submitted',
            data: submissionData.submitted
        },
        {
            name: 'Drafts',
            data: submissionData.drafts
        }
    ];

    return (
        <div className={styles.contentSection}>
            <div className={styles.card}>
                <h2 className={styles.cardTitle}>Submissions Overview</h2>
                <div className={styles.chartContainer}>
                    {submissionData.dates.length > 0 ? (
                        <Chart
                            options={chartOptions}
                            series={chartSeries}
                            type="area"
                            height={350}
                        />
                    ) : (
                        <div className={styles.noData}>
                            <p>No submission data available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SubmissionsChart;